'use client';
import { useRibbonContext } from 'components/ribbon';
import { Container, Header, Spacer, Typo } from 'components/ui-kit';
import { useMedia } from 'hooks';
import { carrotService } from 'lib';
import Link from 'next/link';
import { useUserInfoContext } from 'providers/auth-provider/user-info-provider';
import React, { useEffect } from 'react';
import StickyBox from 'react-sticky-box';
import { FinalPriceAside, OfferForm } from './component';
import { DeliveryProvider } from './component/offer-form/components/delivery-price-provider.component';
import { Breakpoint } from '../../../../_shared';
import { CartPositions } from '../../api';
import { useCartContext } from '../../providers';
import styles from '../../styles/styles.module.scss';

const HEADER_HEIGHT = 123;

export const checkoutTestSelector = {
  unauthorizeMessage: 'unauthorize-message',
};

export const Checkout = (): JSX.Element => {
  const breakpoint = useMedia();
  const isDesktop = breakpoint > Breakpoint.MEDIUM_SCREEN;
  const { cart } = useCartContext();
  const { profile } = useUserInfoContext();
  const { isVisibleRibbon, ribbonHeight } = useRibbonContext();
  const stickyOffset = isVisibleRibbon
    ? ribbonHeight + HEADER_HEIGHT
    : HEADER_HEIGHT;

  useEffect(() => {
    carrotService.orderStarted();
  }, []);

  const preorderProducts = cart?.positions.filter(
    ({ product }: CartPositions) => product.isPreOrder,
  );

  const hasPreorderProduct =
    preorderProducts &&
    preorderProducts.length > 0 &&
    preorderProducts.length !== cart?.positions.length;

  return (
    <Container>
      <DeliveryProvider>
        <section className={styles.cartPage}>
          <div className={styles.cartPageContainer}>
            <Header level={2}>Оформление заказа</Header>
            {!profile && (
              <>
                <Spacer size={32} />
                <Typo dataAt={checkoutTestSelector.unauthorizeMessage}>
                  <Link href="/login?redirectTo=/cart/checkout/">
                    Авторизуйтесь
                  </Link>
                  , чтобы не вводить повторно контактные данные,
                  <br />а также видеть специальные предложения
                </Typo>
              </>
            )}

            {hasPreorderProduct && (
              <>
                <Spacer size={{ s: 24, m: 32 }} />
                <Typo
                  variant="xm"
                  color="alert"
                  className={styles.employeeNotice}
                >
                  В&nbsp;корзине есть товар по&nbsp;предзаказу. Оформите его
                  отдельно, иначе <br className={styles.br} /> остальные товары
                  мы&nbsp;сможем отправить только вместе с&nbsp;предзаказом.
                </Typo>
              </>
            )}
            <Spacer size={!profile ? 48 : 32} />

            {!isDesktop && (
              <>
                <FinalPriceAside />
                <Spacer size={56} />
              </>
            )}

            <OfferForm profile={profile} />
          </div>

          {isDesktop && (
            <div className={styles.cartPageAsideWrapper}>
              <StickyBox offsetTop={stickyOffset}>
                <FinalPriceAside />
              </StickyBox>
            </div>
          )}
        </section>
      </DeliveryProvider>
    </Container>
  );
};
